import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

export class RoutingState {
  private static history = [];

  constructor(
    private router: Router
  ) {}

  public loadRouting(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({urlAfterRedirects}: NavigationEnd) => {
        RoutingState.history = [...RoutingState.history, urlAfterRedirects];
      });
  }

  public static getHistory(): string[] {
    return this.history;
  }

  public static getPreviousUrl(): string {
    return this.history[this.history.length - 2] || null;
  }

  public static getCurrentUrl(): string {
    return this.history[this.history.length - 1] || null;
  }
}